// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + chunkId + "-" + {"167":"f9957a38fb1a0838cf6d","325":"8eee135a35823c6fdc18","636":"b0f6249337e05143ff11"}[chunkId] + ".js";
};